import { sessionService } from "redux-react-session";
import config from "../config";

const base = `${config.apiUrl}/competitors`;

export const announcementService = {
    getActiveAnnouncements,
    getAllAnnouncements,
    createAnnouncement,
    updateAnnouncement,
    deleteAnnouncement,
    submitUserFeedback,
    getAdminUserFeedbacks,
};

// unlike helper.handleResponse: keeps 400 field errors and does not log out on 403 (non-admin)
function handleApiResponse(response) {
    return response.text().then((text) => {
        let data = null;
        try {
            data = text ? JSON.parse(text) : null;
        } catch {
            data = text;
        }
        if (!response.ok) {
            if (response.status === 401) {
                sessionService.deleteSession();
                sessionService.deleteUser();
            }
            const fallback = {
                401: "Your session has expired. Please sign in again.",
                403: "You are not authorised to view this.",
                404: "Not found.",
            }[response.status];
            const detail = data && typeof data === "object" ? data.detail || data.message : null;
            const error = new Error(fallback || detail || response.statusText || "Request failed");
            error.status = response.status;
            error.fieldErrors = response.status === 400 && data && typeof data === "object" ? data : null;
            return Promise.reject(error);
        }
        return data;
    });
}

const authHeaders = (token, json = false) => ({
    Authorization: "Bearer " + token,
    ...(json ? { "Content-Type": "application/json" } : {}),
});

function getActiveAnnouncements(token) {
    return fetch(`${base}/announcement/`, { headers: authHeaders(token) }).then(handleApiResponse);
}

function getAllAnnouncements(token) {
    return fetch(`${base}/admin-announcement/`, { headers: authHeaders(token) }).then(handleApiResponse);
}

function createAnnouncement(token, data) {
    return fetch(`${base}/admin-announcement/`, {
        method: "POST",
        headers: authHeaders(token, true),
        body: JSON.stringify(data),
    }).then(handleApiResponse);
}

function updateAnnouncement(token, id, data) {
    return fetch(`${base}/admin-announcements/${encodeURIComponent(id)}`, {
        method: "PUT",
        headers: authHeaders(token, true),
        body: JSON.stringify(data),
    }).then(handleApiResponse);
}

function deleteAnnouncement(token, id) {
    return fetch(`${base}/admin-announcements/${encodeURIComponent(id)}`, {
        method: "DELETE",
        headers: authHeaders(token),
    }).then(handleApiResponse);
}

// browser sets the multipart boundary, so no Content-Type header here
function submitUserFeedback(token, { competitorId, feedback, file }) {
    const form = new FormData();
    form.append("competitor_id", competitorId);
    form.append("feedback", feedback);
    if (file) form.append("upload_document", file, file.name);
    return fetch(`${base}/competitor-user-feedback/`, {
        method: "POST",
        headers: authHeaders(token),
        body: form,
    }).then(handleApiResponse);
}

function getAdminUserFeedbacks(token) {
    return fetch(`${base}/admin-user-feedbacks/`, { headers: authHeaders(token) }).then(handleApiResponse);
}
